/**
 * @module sign-credentials
 * @description
 * every transaction is confirmed with the account's login and password: identity checks the pair,
 * then the password unlocks the key here, in the browser, as before
 * */

import api from './api';
import { decryptAES } from '@/js/modules/crypto.module';
import { auth } from '@/vuex/auth.module';

// Shaped like an axios error so the existing error.response.data.* handlers in every caller display
// it instead of throwing themselves. One answer for both fields: it does not say which was off.
function invalidCredentials() {
  const err = new Error('invalid_password');
  err.response = { data: { status_code: 401, error_key: 'invalid-password', code: 'INVALID_PASSWORD' } };
  return err;
}

/**
 * @function unlockSeed
 * @param {{ login: string, password: string }} credentials - what the user typed in the confirmation
 * @returns {Promise<string>} the wallet seed
 * */
export async function unlockSeed(credentials) {
  const login = String(credentials?.login || '').trim();
  const password = credentials?.password || '';
  if (!login || !password) throw invalidCredentials();
  const { data } = await api.post('identity/v1/password/validate', { login, password });
  if (!data?.is_valid) throw invalidCredentials();
  const seed = decryptAES(auth.getters.getPrivateData(auth.state).encoded_data, password);
  if (seed === 'invalid_password' || seed === 'undexpected error') throw invalidCredentials();
  return seed;
}
